import React from 'react';
import PropTypes from 'prop-types';
import Row from '../../../core/layout/Row';
import Button from '../../../core/form/Button';
import Select from '../../../core/form/Select';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import LocaleSelect from '../../../core/form/LocaleSelect';
import { get } from 'lodash';

const InstructionVideoListFilter = (props) => (
  <Row>
    <Column size={1.5}>
      <Select
        options={[
          {
            label: 'All',
            value: 'ALL',
          },
          {
            label: 'Student',
            value: 'STUDENT',
          },
          {
            label: 'Kids',
            value: 'KIDS',
          },
          {
            label: 'Parents',
            value: 'PARENTS',
          },
        ]}
        label="Type"
        value={get(props.values, 'type')}
        onChange={(value) => props.onChange('type', value)}
        disabled={props.fetching}
      />
    </Column>
    <Column size={2.5}>
      <TextInput
        label="Search by key"
        value={get(props.values, 'key')}
        onChange={(value) => props.onChange('key', value)}
        disabled={props.fetching}
      />
    </Column>
    <Column size={2.5}>
      <TextInput
        label="Search by link"
        value={get(props.values, 'videoLink')}
        onChange={(value) => props.onChange('videoLink', value)}
        disabled={props.fetching}
      />
    </Column>
    <Column size={1.5}>
      <LocaleSelect
        label="Missing video for key"
        value={get(props.values, 'localeMissingVideo')}
        onChange={(value) => props.onChange('localeMissingVideo', value)}
        disabled={props.fetching}
      />
    </Column>
    <Column size={2}>
      <div style={{ height: 42 }} />
      <Button label="Search" icon="search" onClick={props.onSearch} />
    </Column>
  </Row>
);

InstructionVideoListFilter.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
};

InstructionVideoListFilter.defaultProps = {
  fetching: false,
};

export default InstructionVideoListFilter;
